import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/CheckoutResultPage.css';

type CheckoutResultPageProps = {
  status: 'success' | 'cancel';
};

const CheckoutResultPage: React.FC<CheckoutResultPageProps> = ({ status }) => {
  const navigate = useNavigate();
  const { orderId } = useParams<{ orderId: string }>();
  const isSuccess = status === 'success';

  return (
    <Container className="checkout-result-page">
      <div className="checkout-result-content">
        <div
          className={`checkout-result-mark ${
            isSuccess ? 'checkout-result-mark--success' : ''
          }`}
          aria-hidden="true"
        >
          {isSuccess ? 'OK' : '!'}
        </div>

        <h1>{isSuccess ? 'Payment successful' : 'Payment not completed'}</h1>
        <p>
          {isSuccess
            ? 'Your order has been received. We will notify you as soon as the sellers start processing it.'
            : 'Your order was not placed. Your cart is still available if you want to try again.'}
        </p>

        {isSuccess && (
          <div className="checkout-result-confirmation">
            <span>Order confirmation</span>
            <strong>{orderId || 'Processing'}</strong>
          </div>
        )}

        <div className="checkout-result-actions">
          {isSuccess ? (
            <>
              <Button variant="dark" onClick={() => navigate('/user')}>
                View Orders
              </Button>
              <Button variant="outline-dark" onClick={() => navigate('/products')}>
                Continue Shopping
              </Button>
            </>
          ) : (
            <>
              <Button variant="dark" onClick={() => navigate('/shopping-bag')}>
                Return to Bag
              </Button>
              <Button variant="outline-dark" onClick={() => navigate('/products')}>
                Continue Shopping
              </Button>
            </>
          )}
        </div>
      </div>
    </Container>
  );
};

export default CheckoutResultPage;
